import { Form } from 'antd';

import Input from '@/components/Inputs/Input';

export const PageUrlField = (props: { required?: boolean }) => {
  const { required = false } = props;
  return (
    <Form.Item
      label="Page URL"
      name="page_url"
      required={required}
      rules={
        required ? [{ required: true, message: 'Page URL is required' }] : []
      }
    >
      <Input placeholder="Type page URL" sizeType="m" />
    </Form.Item>
  );
};
